import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import SidePanelController from '../controllers/SidePanelController';
import Tippy, { useSingleton } from '@tippyjs/react';
import { TOOLTIP_DELAY_GENERAL } from '../../../constants';
import { tippyPopoverPlugin } from '../../../utils/tippyPopoverPlugin';

const SidePanelPullTab: React.FC = () => {
  const controller = useController(SidePanelController);
  const { sidePanelItems } = controller.props;

  const [tippySingletonSource, tippySingletonTarget] = useSingleton();

  return (
    <>
      <Tippy
        singleton={tippySingletonSource}
        placement='left'
        zIndex={12000}
        delay={TOOLTIP_DELAY_GENERAL}
        plugins={[tippyPopoverPlugin]}
      />
      {sidePanelItems.map(item => {
        const { tabContent } = item;

        if (!tabContent) {
          return null;
        }

        return (
          <Tippy
            key={item.id}
            content={item.name}
            singleton={tippySingletonTarget}
          >
            <div
              onClick={() => {
                controller.actionOpenSidePanel(item.id);

                window.AhaAnalytics?.track(
                  'Feature-7249764725472497103',
                  `User opens ${item.name.toLowerCase()} tab`,
                  {
                    'Document type': controller.props.documentType,
                  }
                );
              }}
            >
              {tabContent}
            </div>
          </Tippy>
        );
      })}
    </>
  );
};

export default ApplicationView(SidePanelPullTab);
